// extracted by mini-css-extract-plugin
module.exports = {"toggleSwitch":"styles_toggleSwitch__9e9nh","checkbox":"styles_checkbox__tG4Q2","slider":"styles_slider__UP92F"};